import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import Logger from "../../common/utils/Logger";

class DidController extends React.Component {
  state = {};

  componentDidMount() {
    Logger("------------------- inside of did", this.props.route);
  }

  render() {
    return (
      <View style={styles.container}>
        <NtText>DId here</NtText>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default DidController;
